import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.slideActiveIndex = 0;
    _this.direction = '';
    _this.guestsData = [{
      image: require('@/assets/images/avatar/shiyujian.png'),
      name: '施玉坚',
      title: 'vivo高级副总裁'
    }, {
      image: require('@/assets/images/avatar/zhouwei.png'),
      name: '周围',
      title: 'vivo副总裁'
    }, {
      image: require('@/assets/images/avatar/lirui.png'),
      name: '李睿',
      title: 'vivo互联网战略发展部总经理'
    }, {
      image: require('@/assets/images/avatar/langhongxing.png'),
      name: '郎红星',
      title: 'vivo互联网商业运营部总经理'
    }, {
      image: require('@/assets/images/avatar/lili.png'),
      name: '李利',
      title: 'vivo互联网销售中心<br>总经理'
    }, {
      image: require('@/assets/images/avatar/zengkunpeng.png'),
      name: '曾昆鹏',
      title: 'iQOO产品线总经理'
    }, {
      image: require('@/assets/images/avatar/hongzhongjian.png'),
      name: '洪忠建',
      title: 'vivo互联网广告<br>产品总监'
    }, {
      image: require('@/assets/images/avatar/laideyi.png'),
      name: '赖德意',
      title: 'vivo互联网商业运营部商务总监'
    }, {
      image: require('@/assets/images/avatar/yangshanshan.png'),
      name: '杨姗姗',
      title: 'vivo互联网广告行业<br>运营总监'
    }, {
      image: require('@/assets/images/avatar/liujia.png'),
      name: '刘佳',
      title: 'vivo海外广告业务商务总监'
    }, {
      image: require('@/assets/images/avatar/lipingkai.png'),
      name: '李平恺',
      title: 'vivo游戏平台产品总监'
    }, {
      image: require('@/assets/images/avatar/zhangpengfei.png'),
      name: '张鹏飞',
      title: 'vivo游戏商业运营总监'
    }, {
      image: require('@/assets/images/avatar/chengyiming.png'),
      name: '程奕铭',
      title: 'vivo游戏平台运营总监'
    }, {
      image: require('@/assets/images/avatar/liulin.png'),
      name: '刘林',
      title: 'vivo开放生态产品总监'
    }, {
      image: require('@/assets/images/avatar/fuzhouyang.png'),
      name: '付洲洋',
      title: 'vivo应用商店产品总监'
    }, {
      image: require('@/assets/images/avatar/maliangyi.png'),
      name: '马良一',
      title: 'vivo海外互联网<br>产品中心总监'
    }, {
      image: require('@/assets/images/avatar/kejinling.png'),
      name: '柯锦玲',
      title: 'vivo性能优化总监'
    }, {
      image: require('@/assets/images/avatar/wuwencang.png'),
      name: '吴文沧',
      title: 'vivo IoT高级技术总监'
    }, {
      image: require('@/assets/images/avatar/liyangang.png'),
      name: '李延岗',
      title: 'vivo互联网<br>商业产品经理'
    }, {
      image: require('@/assets/images/avatar/wangchengkai.png'),
      name: '王程恺',
      title: 'vivo快应用战略<br>规划经理'
    }, {
      image: require('@/assets/images/avatar/huangzixun.png'),
      name: '黄梓勋',
      title: 'AI解决方案架构经理'
    }, {
      image: require('@/assets/images/avatar/zhangzhongqi.png'),
      name: '张忠琦',
      title: 'Jovi服务平台负责人'
    }, {
      image: require('@/assets/images/avatar/wangbin.png'),
      name: '王斌',
      title: '快应用性能专家'
    }, {
      image: require('@/assets/images/avatar/lujing.png'),
      name: '鲁晶',
      title: 'VCAP计算加速<br>平台负责人'
    }];
    return _this;
  }

  _createClass(Index, [{
    key: "slideChangeHandler",
    value: function slideChangeHandler(delta) {
      this.slideActiveIndex += delta;

      if (delta > 0) {
        this.direction = 'next';
      }

      if (delta < 0) {
        this.direction = 'pre';
      } // const newVal = this.slideActiveIndex += delta;
      // if (newVal < 0) {
      //     this.slideActiveIndex = 1;
      // } else if (newVal === 2) {
      //     this.slideActiveIndex = 0;
      // }

    }
  }]);

  return Index;
}(Vue);

Index = __decorate([Component({
  name: 'ViewGuest',
  components: {}
})], Index);
export default Index; // second-slide': slideActiveIndex === 1,
// 'third-slide': slideActiveIndex === 2,
//     'fourth-slide